import { call, put, select, takeEvery } from 'redux-saga/effects';
import { searchSubmissions } from '@kineticdata/react';
import { C } from '@kineticdata/bundle-common';
import { actions, types } from '../modules/externalOfferings';

export function* fetchExternalOfferingsSaga() {
  const authenticated = yield select(state => state.app.authenticated);

  const { submissions, error } = yield call(searchSubmissions, {
    kapp: C.KAPP_SLUG_ADMIN,
    form: C.FORM_SLUG_EXTERNAL_SERVICE_OFFERINGS,
    limit: 1000,
    search: {
      include: ['details', 'values'],
    },
    public: !authenticated,
  });

  if (error) {
    yield put(actions.fetchExternalOfferingsFailure(error));
  } else {
    yield put(actions.fetchExternalOfferingsSuccess(submissions));
  }
}

export function* watchExternalOfferings() {
  yield takeEvery(
    types.FETCH_EXTERNAL_OFFERINGS_REQUEST,
    fetchExternalOfferingsSaga,
  );
}
